<template lang="pug">
#filtros-dashboard.mb-3.mt-5
    el-collapse(style='border: none')
        el-collapse-item(name='filtros', :disabled='true')
            .titulo-filtro-laudos(slot="title")
                i(class="mdi mdi-filter-outline filter-icon")
                span {{ $t('mensagens.laudos.filtros') }}

            el-form(
                label-position='top',
                size='mini',
                :class='perfilAnalista ? "fields-analista" : "fields"'
            )
                el-form-item.territorio
                    label {{ $t('mensagens.laudos.territorio') }}
                    el-select(
                        v-model='filtros.territoriosIds',
                        :placeholder="$t('mensagens.comuns.selecione')",
                        filterable,
                        remote,
                        multiple,
                        reserve-keyword,
                        :remote-method='remoteMethodTerritorio'
                    )
                        el-option(
                            v-for='territorio in listaTerritorios',
                            :key='`${territorio.nome}${territorio.id}`',
                            :label='territorio.nome',
                            :value='territorio.id'
                        )
                            | {{ territorio.nome }}

                el-form-item.situacao
                    label {{ $t('mensagens.laudos.situacao') }}
                    el-select(v-model='filtros.situacaoId', :placeholder="$t('mensagens.comuns.selecione')",)
                        el-option(
                            v-for='situacao in situacoesPossiveis',
                            :key='situacao.codigo',
                            :label='situacao.nome',
                            :value='situacao.id'
                        )
                            | {{ situacao.nome }}

                el-form-item.solicitacao
                    label {{ $t('mensagens.laudos.dataSolicitacao') }}
                    .date
                        el-date-picker(
                            v-model='filtros.dataCadastroInicio',
                            type='date',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )
                        span à
                        el-date-picker(
                            v-model='filtros.dataCadastroFim',
                            type='date',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )

                el-form-item.entrega
                    label {{ $t('mensagens.laudos.dataEntrega') }}
                    .date
                        el-date-picker(
                            v-model='filtros.dataFinalizacaoInicio',
                            type='date',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )
                        span à
                        el-date-picker(
                            v-model='filtros.dataFinalizacaoFim',
                            type='date',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )

                el-form-item.actions
                    .buttons
                        BaseButton.mr-10(
                            icon='el-icon-delete',
                            @click='limparFiltros'
                        ) {{ $t('mensagens.comuns.limpar') }}
                        BaseButton(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='criarFiltro'
                        ) {{ $t('mensagens.comuns.filtrar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import Formatters from '@/utils/formatters';
import TipoLaudo from '@/constants/TipoLaudo';
import { ordem } from '@/utils/ordenacao';
import authService from '@/services/AuthService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'Filtros',

    components: {
        BaseButton
    },

    emits: ['getFiltros'],

    data() {
        return {
            listaTerritorios: [],
            situacoesPossiveis: [],
            perfilAnalista: null,
            filtros: {
                territoriosIds: '',
                situacaoId: '',
                dataCadastroInicio: '',
                dataCadastroFim: '',
                dataFinalizacaoInicio: '',
                dataFinalizacaoFim: '',
                tipoLaudoId: TipoLaudo.AVALIACAO_FUNDIARIA
            }
        };
    },

    created() {
        this.getUsuario();
        this.getSituacoes();
        this.buscarTerritorios('');
        this.limparFiltros();
    },

    methods: {
        async getUsuario() {
            const { data, status } = await authService.isLogged();
            if (status === 200 && data != null) {
                if (data.isAnalyst) {
                    this.perfilAnalista = data.isAnalyst;
                }
            }
        },

        getFiltro(query) {
            if (query) {
                const cpfCnpj = Formatters.documentoFormatToNumeral(query);
                if (cpfCnpj === '') {
                    return query;
                }

                return cpfCnpj;
            }

            return '';
        },

        getSituacoes() {
            LaudosService.getSituacoesPossiveis().then(({ data }) => {
                this.situacoesPossiveis = data;
            });
        },

        remoteMethodTerritorio(query) {
            setTimeout(() => {
                this.buscarTerritorios(query);
            }, 1000);
        },

        buscarTerritorios(query) {
            LaudosService.getTerritorios(this.getFiltro(query)).then(
                ({ data }) => {
                    this.listaTerritorios = data.sort(ordem);
                }
            );
        },

        limparFiltros() {
            this.filtros = {
                territoriosIds: [],
                situacaoId: '',
                dataCadastroInicio: '',
                dataCadastroFim: '',
                dataFinalizacaoInicio: '',
                dataFinalizacaoFim: '',
                tipoLaudoId: TipoLaudo.AVALIACAO_FUNDIARIA
            };
            this.$emit('getFiltros', this.filtros);
        },

        criarFiltro() {
            this.$emit('getFiltros', this.filtros);
        }
    }
};
</script>

<style scoped lang="scss">
#filtros-dashboard {
    background-color: var(--white);
    width: 100%;
    padding: 0 15px;
    overflow: hidden;
    border-radius: 4px;
    pointer-events: none;

    .fields {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-areas:
            'territorio territorio territorio situacao situacao situacao'
            'solicitacao solicitacao solicitacao entrega entrega entrega'
            'vazio vazio vazio vazio vazio acoes';

        column-gap: 15px;

        .territorio {
            grid-area: territorio;
        }
        .situacao {
            grid-area: situacao;
        }
        .solicitacao {
            grid-area: solicitacao;
        }
        .entrega {
            grid-area: entrega;
        }
        .actions {
            grid-area: acoes;
        }
    }

    .fields-analista {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-areas:
            'territorio territorio territorio situacao situacao situacao'
            'solicitacao solicitacao solicitacao entrega entrega entrega'
            'vazio vazio vazio vazio vazio acoes';

        column-gap: 15px;

        .territorio {
            grid-area: territorio;
        }
        .situacao {
            grid-area: situacao;
        }
        .solicitacao {
            grid-area: solicitacao;
        }
        .entrega {
            grid-area: entrega;
        }
        .actions {
            grid-area: acoes;
        }
    }

    label {
        margin-bottom: -5px;
    }

    .el-select {
        margin-top: -20px;
        width: 100%;
    }

    .el-date-picker {
        width: 40%;
    }

    .date {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .actions {
        margin-bottom: 0;

        .buttons {
            display: flex;
            justify-content: flex-end;
            margin-top: 15px;
        }
    }
}
</style>
